import PropTypes from 'prop-types';

export default PropTypes.shape({
  lenderId: PropTypes.string.isReqired,
  name: PropTypes.string.isReqired,
  bankPortalForBroker: PropTypes.string,
});
